import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=796b5b37&scoped=true"
import script from "./layout?vue&type=script&lang=js&external"
export * from "./layout?vue&type=script&lang=js&external"
import style0 from "./layout.vue?vue&type=style&index=0&id=796b5b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b5b37",
  null
  
)

export default component.exports